import { Challenge, ChallengeWithUser, ChallengeStatus } from '../../domain/models';

// Entity representing the database structure
export interface ChallengeEntity {
  id: string;
  challenger_id: string;
  challenged_id: string;
  tournament_id?: string;
  status: 'pending' | 'accepted' | 'declined' | 'cancelled';
  message?: string;
  created_at: string;
  updated_at: string;
}

export interface ChallengeWithUserEntity extends ChallengeEntity {
  challenger_name?: string;
  challenger_email?: string;
  challenger_avatar_url?: string;
  challenged_name?: string;
  challenged_email?: string;
  challenged_avatar_url?: string;
}

// Mapper: from Entity (DB) to Model (Domain)
export const challengeEntityToModel = (entity: ChallengeEntity): Challenge => {
  return {
    id: entity.id,
    challengerId: entity.challenger_id,
    challengedId: entity.challenged_id,
    tournamentId: entity.tournament_id,
    status: entity.status as ChallengeStatus,
    message: entity.message,
    createdAt: new Date(entity.created_at),
    updatedAt: new Date(entity.updated_at),
  };
};

export const challengeWithUserEntityToModel = (
  entity: ChallengeWithUserEntity
): ChallengeWithUser => {
  return {
    id: entity.id,
    challengerId: entity.challenger_id,
    challengedId: entity.challenged_id,
    tournamentId: entity.tournament_id,
    status: entity.status as ChallengeStatus,
    message: entity.message,
    createdAt: new Date(entity.created_at),
    updatedAt: new Date(entity.updated_at),
    userName: entity.challenger_name || entity.challenged_name,
    userEmail: entity.challenger_email || entity.challenged_email,
    userAvatarUrl: entity.challenger_avatar_url || entity.challenged_avatar_url,
  };
};

// Mapper: from Model (Domain) to Entity (DB)
export const challengeModelToEntity = (model: Partial<Challenge>): Partial<ChallengeEntity> => {
  return {
    id: model.id,
    challenger_id: model.challengerId,
    challenged_id: model.challengedId,
    tournament_id: model.tournamentId,
    status: model.status,
    message: model.message,
    created_at: model.createdAt?.toISOString(),
    updated_at: model.updatedAt?.toISOString(),
  };
};
